/** Root reducer combining each module's reducers. */

import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import AdminReducer from '../modules/admin/reducers';
import CarerReducer from '../modules/carers/reducers';
import ClientReducer from '../modules/clients/reducers';


export const reducersObject = {
  form: formReducer,
  admin: AdminReducer,
  carer: CarerReducer,
  client: ClientReducer,
};

const appReducer = combineReducers(reducersObject);

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
